module.exports = __webpack_public_path__ + "img/kim-jiyoung-born-1982.f2c92311.png";